// extracted by mini-css-extract-plugin
module.exports = {"features-wrapper":"Features_features-wrapper__JR8D_","box1":"Features_box1__5wWCm","box2":"Features_box2__8dbfX"};